<template>
  <div>
    <headerComponent @search="upEmit"/>
  </div>
</template>

<script>
  const dirName = process.env.siteName === 'yongligao' || process.env.siteName === 'taiyangcheng018' || process.env.siteName === 'veniceman' || process.env.siteName === 'betl' || process.env.siteName === 'b027site' || process.env.siteName === 'b027sport' ? process.env.siteName : 'common'
  const headerComponent = () => import('@/components/different/' + dirName + '/header/header')
  export default {
    name: 'v-header',
    components: {
      headerComponent
    },
    methods: {
      upEmit (data) {
        this.$emit('search', data)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// header.vue?4aaa276e